/**
 * Authentication logger that respects VITE_DEBUG_LOGGING environment variable
 *
 * Set VITE_DEBUG_LOGGING=true to enable detailed authentication logging
 * Default is false (no auth logging)
 */

import log from "loglevel"
import { config } from "./config"

// Configure log level based on environment variable
const isDebugEnabled = config.debugLogging
const authLogLevel = isDebugEnabled ? log.levels.DEBUG : log.levels.SILENT

// Create a logger instance for authentication
const logger = log.getLogger("auth")
logger.setLevel(authLogLevel)

/**
 * Logger for authentication-related events in the frontend
 *
 * Uses loglevel library with level controlled by VITE_DEBUG_LOGGING
 */
export const authLogger = {
  log: logger.debug.bind(logger),
  warn: logger.warn.bind(logger),
  error: logger.error.bind(logger),
}
